import { styled } from "simplydo/react/styled";

const Line = styled.span`
  display: inline-block;
  align-self: center;
  vertical-align: middle;
  flex: none;
  width: 1px;
  height: 24px;
  margin: 0 0.45em;
  background: #e4e7ec;

  *:has(+ &) {
    margin-right: 0 !important;
  }
`;

/**
 * A vertical line between groups of buttons. It spaces itself like a button
 * and cancels the margin of the control before it, so both sides match.
 */
export const ButtonDivider = () => <Line aria-hidden />;
